import React, { useState, useEffect } from 'react'
import { Button, Col, Row, Collapse } from 'antd'
import { Data, DeleteInquiryReq, DeliveryCostConfigs } from 'Store/delivery-cost/types'
import CostConfig from 'Pages/DeliveryCost/CostConfig'
import { cloneDeep } from 'lodash'
import { PlusOutlined } from '@ant-design/icons'
import { connect, useDispatch } from 'react-redux'
import { selectCurrentUser } from 'Store/user/selector'
import RootState from 'typings/RootState'
import { inquiryDeleteDeliveryCostAPI } from 'Store/delivery-cost/api'
import { clearEventAction } from 'Store/delivery-cost/actions'
import { EventModal } from 'Components/modal'
import { selectInquiryDeleteEvent } from 'Store/delivery-cost/selector'
const { Panel } = Collapse

type Props = {
  distanceDataList: Data[]
  onUpdate: (distanceData: Data[]) => void
  mid: number
} & ReduxProps

const DeliveryCostConfig: React.FunctionComponent<Props> = props => {
  const { distanceDataList, onUpdate, currentUser, event, mid } = props
  const dispatch = useDispatch()
  const [deleteID, setDeleteID] = useState(0)
  const [distanceList, setDistanceList] = useState([] as Data[])
  const initDataList = [
    {
      start: 0,
      end: 200,
      variable_price: 15,
      start_price: 0,
    },
  ] as DeliveryCostConfigs[]

  const deleteInquiry = (id: number) => {
    const req: DeleteInquiryReq = {
      id: id,
    }
    dispatch(
      inquiryDeleteDeliveryCostAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''),
    )
  }

  useEffect(() => {
    setDistanceList(distanceDataList)
  }, [distanceDataList])

  const onAddNewConfig = () => {
    const newConfig = {
      title: `ขนส่งแบบพิเศษ ${distanceList.length}`,
      max_distance: 200,
      delivery_cost_configs: cloneDeep(initDataList),
      type: 'distance',
      merchant_id: mid,
    } as Data
    const newList = cloneDeep(distanceList)
    newList.push(newConfig)
    setDistanceList(newList)
    onUpdate(newList)
  }

  const onUpdateData = (index: number, data: Data) => {
    const newList = cloneDeep(distanceList)
    newList[index] = data
    setDistanceList(newList)
    onUpdate(newList)
  }

  const onDeleteDataFromIndex = (deleteIndex: number) => {
    let newList = cloneDeep(distanceList)
    newList = newList.filter((item, index) => index !== deleteIndex)
    setDistanceList(newList)
    onUpdate(newList)
  }

  const onDeleteDataFromId = (id: number) => {
    let newList = cloneDeep(distanceList)
    newList = newList.filter(item => item.id !== id)
    setDistanceList(newList)
    onUpdate(newList)
  }

  const onDeleteData = (deleteIndex: number, id: number) => {
    if (id === 0) {
      onDeleteDataFromIndex(deleteIndex)
    } else {
      deleteInquiry(id)
      setDeleteID(id)
    }
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
    setDeleteID(0)
  }

  const onEventSuccess = (): void => {
    clearEvent()
    onDeleteDataFromId(deleteID)
  }

  return (
    <Row gutter={[16, 16]}>
      <EventModal
        key="inquiry-delete"
        event={[event]}
        enable={true}
        successCalback={onEventSuccess}
        errorCalback={clearEvent}
      />
      <Col span={24}>
        <Collapse collapsible="header" ghost defaultActiveKey={['1']}>
          <Panel header="คำนวนอัตราค่าขนส่งจากระยะทาง" key="1">
            <Row gutter={[8, 8]}>
              {cloneDeep(distanceList).map((distance, index) => {
                return (
                  <Col span={24} key={`${distance.title}-${index}`}>
                    <CostConfig
                      configData={distance}
                      type="distance"
                      onUpdateData={(data: Data) => onUpdateData(index, data)}
                      onDelete={() => onDeleteData(index, distance.id || 0)}
                    />
                  </Col>
                )
              })}
              {distanceList.length < 6 && (
                <Col span={24}>
                  <Button type="dashed" block onClick={onAddNewConfig} icon={<PlusOutlined />}>
                    เพิ่มอัตราค่าขนส่งแบบพิเศษ
                  </Button>
                </Col>
              )}
            </Row>
          </Panel>
        </Collapse>
      </Col>
    </Row>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectInquiryDeleteEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(DeliveryCostConfig)
